export const TransactionType = {
  GET_TRANSACTION_REQUEST: "GET_TRANSACTION_REQUEST",
  GET_TRANSACTION_SUCCESS: "GET_TRANSACTION_SUCCESS",
  GET_TRANSACTION_FAIL: "GET_TRANSACTION_FAIL",
  GET_TRANSACTION_COUNT_REQUEST: "GET_TRANSACTION_COUNT_REQUEST",
  GET_TRANSACTION_COUNT_SUCCESS: "GET_TRANSACTION_COUNT_SUCCESS",
  GET_TRANSACTION_COUNT_FAIL: "GET_TRANSACTION_COUNT_FAIL",
  GET_IAP_DETAIL_REQUEST: "GET_IAP_DETAIL_REQUEST",
  GET_IAP_DETAIL_SUCCESS: "GET_IAP_DETAIL_SUCCESS",
  GET_IAP_DETAIL_FAIL: "GET_IAP_DETAIL_FAIL"
};
